import React, { useContext, useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { format, isSameDay, startOfDay, endOfDay, subDays } from 'date-fns';
import Calendar$1 from 'react-calendar';
import styled from 'styled-components';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var Calendar = function Calendar(props) {
  var className = props.className,
      otherProps = _objectWithoutProperties(props, ["className"]);

  var classNames = ["ssnet-icon", className].join(" ");
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 56 56"
  }, otherProps, {
    className: classNames
  }), React.createElement("path", {
    d: "M9 49h38a1 1 0 0 0 1-1V22a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v26a1 1 0 0 0 1 1zm37-10.67h-7.5v-6.66H46zm-9.5 0H29v-6.66h7.5zm-7.5 2h7.5V47H29zM27 47h-7.5v-6.67H27zm2-17.33V23h7.5v6.67zm-2 0h-7.5V23H27zm0 2v6.67h-7.5v-6.67zm-9.5 6.67H10v-6.67h7.5zm-7.5 2h7.5V47H10zM38.5 47v-6.67H46V47zM46 29.67h-7.5V23H46zM17.5 23v6.67H10V23z"
  }), React.createElement("path", {
    d: "M55 4h-9V1a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1v3H20V1a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1v3H1a1 1 0 0 0-1 1v50a1 1 0 0 0 1 1h54a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zM38 2h6v6h-6V2zM12 2h6v6h-6V2zm42 52H2V16h52zm0-40H2V6h8v3a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6h16v3a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6h8z"
  }));
};

var DateButton = function DateButton(props) {
  var isSelected = props.isSelected,
      _onClick = props.onClick,
      value = props.value,
      children = props.children,
      className = props.className;
  return React.createElement("div", {
    className: className
  }, React.createElement("div", {
    onClick: function onClick() {
      _onClick();
    },
    className: "mx-2 date-button btn btn-sm btn-outline-".concat(isSelected ? "primary date-button-active" : "secondary date-button-inactive", " mr-2"),
    style: {
      cursor: "pointer",
      borderRadius: "0.45em"
    }
  }, value ? value : children));
};

var ColorContext = React.createContext();
var ColorContextProvider = ColorContext.Provider;

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    fill: ", " !important;\n    border: none;\n\n    .react-calendar__tile--active {\n      background-color: ", " !important;\n    }\n\n    .react-calendar__tile--hasActive {\n      background-color: ", " !important;\n      opacity: 0.4 !important;\n    }\n    .react-calendar {\n      border: none !important;\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var withCalendarStyles = (function (component) {
  var _useContext = useContext(ColorContext),
      activeColor = _useContext.activeColor;

  return styled(component)(_templateObject(), activeColor, activeColor, activeColor);
});

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n    .date-button {\n      transition: 0s !important;\n    }\n    .date-button:hover {\n      color: #fff !important;\n    }\n\n    .date-button-active {\n      color: ", " !important;\n      border-color: ", " !important;\n    }\n\n    .date-button-active:hover {\n      background-color: ", " !important;\n    }\n\n    .date-button-inactive {\n      color: ", " !important;\n      border-color: ", " !important;\n    }\n\n    .date-button-inactive:hover {\n      background-color: ", " !important;\n    }\n  "]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var withDateButtonStyles = (function (datebutton) {
  var _useContext = useContext(ColorContext),
      activeColor = _useContext.activeColor,
      inactiveColor = _useContext.inactiveColor;

  return styled(datebutton)(_templateObject$1(), activeColor, activeColor, activeColor, inactiveColor, inactiveColor, inactiveColor);
});

var CalendarContainer = styled.div({
  padding: "1em",
  marginTop: "0.5rem",
  position: "absolute",
  transform: "translateY(calc(50% + 1.5em))",
  boxShadow: "0 0 12px rgba(0, 0, 0, 0.25)",
  borderRadius: "1rem",
  backgroundColor: "#fff"
});

var useOutsideClick = (function (calendarRef, buttonRef, callback) {
  var handleClickOutside = function handleClickOutside(event) {
    if (calendarRef.current && !calendarRef.current.contains(event.target) && buttonRef.current && !buttonRef.current.contains(event.target)) {
      callback();
    }
  };

  useEffect(function () {
    document.addEventListener("mousedown", handleClickOutside);
    return function () {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  });
});

var GraphDateControls = function GraphDateControls(props) {
  var startDate = props.startDate,
      endDate = props.endDate,
      mode = props.mode,
      selectionCallback = props.selectionCallback,
      showButtons = props.showButtons,
      showToday = props.showToday,
      showWeek = props.showWeek,
      showMonth = props.showMonth,
      showLifetime = props.showLifetime,
      zIndex = props.zIndex;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      pickerOpen = _useState2[0],
      setPickerOpen = _useState2[1];

  var _useState3 = useState([startDate, endDate]),
      _useState4 = _slicedToArray(_useState3, 2),
      dateRange = _useState4[0],
      setDateRange = _useState4[1];

  var _useState5 = useState(mode ? mode : "TODAY"),
      _useState6 = _slicedToArray(_useState5, 2),
      localMode = _useState6[0],
      setLocalMode = _useState6[1];

  var lastDaySelected = useRef(null);
  var StyledCalendar = withCalendarStyles(Calendar$1);
  var StyledDateButton = withDateButtonStyles(DateButton);

  var _useContext = useContext(ColorContext),
      activeColor = _useContext.activeColor;

  var calendarRef = useRef(null);
  var buttonRef = useRef(null);
  useOutsideClick(calendarRef, buttonRef, function () {
    toggleDatePicker();
  });

  var toggleDatePicker = function toggleDatePicker() {
    setPickerOpen(!pickerOpen);
  }; // update localmode when given external input


  useEffect(function () {
    setLocalMode(mode);
  }, [mode]);
  return React.createElement("div", {
    className: "".concat(props.className, " d-flex align-items-center justify-content-center py-3")
  }, React.createElement("div", {
    className: "h3 m-0 mr-3 d-flex align-items-center",
    "aria-expanded": pickerOpen,
    ref: buttonRef
  }, React.createElement(Calendar, {
    style: {
      cursor: "pointer",
      fill: activeColor
    },
    width: "1.5em",
    onClick: toggleDatePicker
  })), pickerOpen && React.createElement(React.Fragment, null, React.createElement(CalendarContainer, {
    ref: calendarRef,
    style: {
      zIndex: zIndex
    }
  }, React.createElement("div", {
    className: "d-flex flex-row justify-content-center"
  }, React.createElement("div", {
    className: "text-center m-1"
  }, localMode === "LIFETIME" ? "Lifetime" : localMode === "TODAY" ? format(startDate, "DD MMM YYYY") : "".concat(format(startDate, "DD MMM YYYY"), "\n                - ").concat(format(endDate, "DD MMM YYYY")))), React.createElement("div", {
    className: "my-3"
  }, React.createElement(StyledCalendar, {
    selectRange: true,
    onChange: function onChange(date) {
      setDateRange(date);
    },
    onClickDay: function onClickDay(date) {
      lastDaySelected.current = date;
    },
    value: dateRange
  })), React.createElement("div", {
    className: "d-flex flex-row justify-content-center"
  }, React.createElement(StyledDateButton, {
    onClick: function onClick() {
      // supports single click without selecting a range
      var doubleClick = !lastDaySelected.current || isSameDay(dateRange[1], lastDaySelected.current) || isSameDay(dateRange[0], lastDaySelected.current);

      var _dateRange = doubleClick ? dateRange : [startOfDay(lastDaySelected.current), endOfDay(lastDaySelected.current)];

      if (!doubleClick) {
        setDateRange(_dateRange);
      } // stops no data from showing if they load the graph without adding any dates since lifetime


      if (localMode === "LIFETIME" && !dateRange) {
        selectionCallback("LIFETIME", null, null);
      } else {
        setLocalMode("CUSTOM");
        selectionCallback("CUSTOM", _dateRange[0], _dateRange[1]);
      }

      toggleDatePicker();
    },
    isSelected: true,
    value: "Load Graph"
  }), React.createElement(StyledDateButton, {
    onClick: function onClick() {
      toggleDatePicker();
    },
    isSelected: false,
    value: "Cancel"
  })))), showToday && showButtons && React.createElement(StyledDateButton, {
    onClick: function onClick() {
      var today = new Date();
      var range = [today, today];
      setDateRange(range);
      setLocalMode("TODAY");
      selectionCallback("TODAY", range[0], range[1]);
    },
    isSelected: localMode === "TODAY",
    value: "Today"
  }), showWeek && showButtons && React.createElement(StyledDateButton, {
    onClick: function onClick() {
      var today = new Date();
      var range = [subDays(today, 7), today];
      setDateRange(range);
      setLocalMode("WEEK");
      selectionCallback("WEEK", range[0], range[1]);
    },
    isSelected: localMode === "WEEK",
    value: "Past 7 Days"
  }), showMonth && showButtons && React.createElement(StyledDateButton, {
    onClick: function onClick() {
      var today = new Date();
      var range = [subDays(today, 30), today];
      setDateRange(range);
      setLocalMode("MONTH");
      selectionCallback("MONTH", range[0], range[1]);
    },
    isSelected: localMode === "MONTH",
    value: "Past 30 Days"
  }), showLifetime && showButtons && React.createElement(StyledDateButton, {
    onClick: function onClick() {
      var range = [null, null];
      setDateRange(range);
      setLocalMode("LIFETIME");
      selectionCallback("LIFETIME", range[0], range[1]);
    },
    isSelected: localMode === "LIFETIME",
    value: "Lifetime"
  }));
};

var StyledGraphDateControls = function StyledGraphDateControls(props) {
  // fallback to default solarschools style
  var activeColor = props.activeColor || "#ea7525";
  var inactiveColor = props.inactiveColor || "#525d63";
  return React.createElement(ColorContextProvider, {
    value: {
      activeColor: activeColor,
      inactiveColor: inactiveColor
    }
  }, React.createElement(GraphDateControls, props));
};

GraphDateControls.propTypes = {
  mode: PropTypes.oneOf(["TODAY", "WEEK", "MONTH", "LIFETIME", "CUSTOM"]),
  selectionCallback: PropTypes.func.isRequired
};
GraphDateControls.defaultProps = {
  showButtons: true,
  showToday: true,
  showWeek: false,
  showMonth: true,
  showLifetime: true,
  zIndex: 100
};

export default StyledGraphDateControls;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@solarschools/component-lib/components/GraphDateControls/index.js
// module id = keFL
// module chunks = 3